/* Package JSON Import will be here */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getTranslate } from "react-localize-redux";
import Img from "react-image";
import { Card, Badge, Row, Col, Space, Typography, Tag } from "antd";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getCultureNumberFormat } from "utilities/utils";
import placeholderImg from "assets/img/banner-placeholder.png";
import { ImageLoader } from "components/Spinner";
import Constants from "../../utilities/appConstants";
import { updateFavProductStatus } from "reducers/favouriteProducts";
import TooltipComp from "components/reusable/TooltipComp";
import { setSelectedProductId } from "reducers/common";
import { resetProductDetails } from "reducers/product/productDetails";
import ProductDetailsDrawer from "components/products/ProductDetailsDrawer";
import OfferRibbon from "components/reusable/OfferRibbon";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
let isFavDisabled = false;
/* Const,Let & Var will be here */

class HorizontalProductItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentSelectionId: this.props.variants[0],
      drawerVisible: false

    };
  }

  toggleDrawer = () => {
    this.setState((prevState) => ({
      drawerVisible: !prevState.drawerVisible,
    }));
  };

  onVariantClick = id => {
    this.setState({ currentSelectionId: id });
  };

  getBadgeClass = key => {
    const { cart } = this.props;

    if (this.state.currentSelectionId === key)
      return "badge--gram badge-selected";
    else if (cart.data[key])
      return "badge--gram badge-active";
    else
      return "badge--gram";
  };

  /* Navigate to product details page */
  openProductDetailsModal = async () => {
    /* Assign the values to temp variable in similar products */
    if (this.props.type === Constants.REDUCER_SIMILAR_PRODUCTS) {
      /* remove selected product id when the user leave the product details page */
      await this.props.actions.setSelectedProductId(0);

      /* Reset product details before leaving from the product details page */
      await this.props.actions.resetProductDetails();
    }

    /* Toggle the retailer to product details drawer */
    this.toggleDrawer();
  }

  /* add or remove the product from fav product */
  addOrRemoveFavProduct = (productInfo) => {
    if (!isFavDisabled)
      this.props.actions.updateFavProductStatus(productInfo, () => { isFavDisabled = false });

    isFavDisabled = true;
  };

  getCardContent = (product) => {
    const { variants, products, translate, appSettings } = this.props;

    return (
      <React.Fragment>
        <Card
          className="product-horizontal-scroll-card ant-card-with-box-shadow border-radius-15"
        >
          {appSettings.isFavProductEnable &&
            <div className="fav-icon-position" onClick={() => { this.addOrRemoveFavProduct(product) }}>
              {product.IsFavourite ? <i className="fa fa-heart fa-lg float-right fav-product-icon-color" aria-hidden="true"></i> : <i className="fa fa-heart-o fa-lg float-right" aria-hidden="true"></i>}
            </div>
          }

          <Row
            className="mt-2"
            onClick={e => { this.openProductDetailsModal() }}>
            <Col span={24} className="text-center home-slider-image-height">
              <Img
                className="home-slider-image  home-slider-image-height pb-2 border-radius-15 cursor-pointer"
                src={[product.ImageUrl, placeholderImg]}
                alt=""
                loader={<ImageLoader />}
              />
            </Col>

            {/* SIH no stock error message */}

            <div className="text-center h-22 w-100">
              {appSettings.isShowSIHColorCode && product.SIH === 0 &&
                <Tag className="round-radius mr-0 stockRedStyle font-10" color="#ff0000">{translate("products.productLabel.outOfStock")}</Tag>
              }
            </div>

          </Row>

          <Row>
            <Col span={appSettings.isShowColorCode ? 22 : 24}>
              <TooltipComp title={product.ProductName}>
                <h6 className="text-truncate cursor-default">{product.ProductName}</h6>
              </TooltipComp>
            </Col>
            {(appSettings.isShowColorCode && product.Purchased !== undefined && product.Purchased !== 0) &&
              <Col span={2} className="text-center">
                <Badge status="processing" />
              </Col>
            }
          </Row>

          <Row className="mb-2 cursor-default">
            <Col span={24}>
              <Row>
                {appSettings.isEnableMRP && <Col span={24} className="p-1">
                  <i className="fa fa-tag" aria-hidden="true"></i>
                  <span>{` ${translate("products.productLabel.mrp")} : `}</span>
                  <span className="product-horizontal-price-font">{`${getCultureNumberFormat(product.MRP.toFixed(2), true)}`}</span>
                </Col>
                }
                {appSettings.isEnableSP &&
                  <Col span={24} className="p-1">
                    <i className="fa fa-tag" aria-hidden="true"></i>
                    <span>{` ${translate("products.productLabel.ptr")} : `}</span>
                    <span className="product-horizontal-price-font">{`${getCultureNumberFormat(product.SellPrice.toFixed(2), true)}`}</span>
                  </Col>
                }
              </Row>
            </Col>
          </Row>

          {(appSettings.isShowStockQty || (appSettings.isEnablePlaceOrderCase && appSettings.isShowConversionQtyLabel) || appSettings.isEnableMinOrderQty) &&
            <Space size="middle" className="flex-wrap p-1 horizontal-product-p-extra-info-min-height">
              {appSettings.isShowStockQty &&
                <span>
                  <Badge color="orange" />
                  <Text className="font-12">{translate("products.productLabel.stockQty")} : {product.SIH}</Text>
                </span>
              }

              {(appSettings.isEnablePlaceOrderCase && appSettings.isShowConversionQtyLabel) &&
                <span>
                  <Badge color="orange" />
                  <Text className="font-12">{translate("products.productLabel.ConversionQtyCase")} : {product.ConversionQty}{translate("products.productLabel.unit")}</Text>
                </span>
              }

              {(appSettings.isEnableMinOrderQty && product.MinORDQty > 0) &&
                <span>
                  <Badge color="orange" />
                  <Text className="font-12">{translate("products.productLabel.minQty")} : {product.MinORDQty}</Text>
                </span>
              }
            </Space>
          }

          {/* Check for variant */}
          {(products[variants[0]] && products[variants[0]].Variant) &&
            <div className="horizontal-product-variant">
              {variants.slice(0, 2).map(key => {
                return (
                  <div key={key}>
                    {products[key] &&
                      products[key].Variant && (
                        <React.Fragment>
                          <span
                            onClick={e => {
                              e.stopPropagation();
                              this.onVariantClick(key);
                            }}
                            className={`${this.getBadgeClass(key)}`}
                          >
                            {products[key].Variant}
                          </span>
                        </React.Fragment>
                      )}
                  </div>
                );
              })}
            </div>
          }

          {/* Show view all variant button */}
          {variants.length > 2 &&
            <div className="horizontal-product-p-extra-info-min-height">
              <Row className="w-100 text-center font-12">
                <Col className="color-primary" span={24} onClick={e => { this.openProductDetailsModal() }}>{translate("products.productLabel.viewAllVariants")}</Col>
              </Row>
            </div>
          }
        </Card>
      </React.Fragment >
    );
  }

  render() {
    const product = this.props.products[this.state.currentSelectionId];
    const { translate } = this.props;

    return (
      <React.Fragment>
        <React.Fragment>
          <OfferRibbon product={product} pageType={Constants.PAGE_TYPE_RECOMMENDED} translate={translate}>
            {this.getCardContent(product)}
          </OfferRibbon>
        </React.Fragment>

        {/* Product details page drawer */}
        <ProductDetailsDrawer
          currentSelectionId={product.ProductId}
          drawerVisible={this.state.drawerVisible}
          toggleDrawer={this.toggleDrawer}
        />
      </React.Fragment >
    );
  }
}

const mapStateToProps = state => {
  return {
    orders: state.orders,
    cart: state.cart,
    appSettings: state.appSettings,
    translate: getTranslate(state.locale)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        updateFavProductStatus,
        setSelectedProductId,
        resetProductDetails
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HorizontalProductItem);